'use client';

import { useSelectedLayoutSegment } from 'next/navigation';
import type React from 'react';
import { Provider } from 'react-redux';
import { Slide, ToastContainer } from 'react-toastify';
import { MSWProvider } from 'src/mocks/msw-provider';
import store from 'src/redux/store';

import LaunchDarklyProvider from 'src/components/launchdarkly-provider';

interface ProvidersProps {
	children: React.ReactNode;
}

export default function Providers({ children }: ProvidersProps) {
	const segment = useSelectedLayoutSegment();
	const coreTree = (
		<Provider store={store}>
			{children}
			<ToastContainer
				position="bottom-right"
				autoClose={3000}
				hideProgressBar
				newestOnTop={false}
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
				closeButton={false}
				closeOnClick={false}
				transition={Slide}
			/>
		</Provider>
	);

	const appTree =
		process.env.NODE_ENV === 'development' ? (
			<MSWProvider>{coreTree}</MSWProvider>
		) : (
			coreTree
		);

	// The portal owns its provider below AuthProvider so its first context is known.
	return segment === '(portal)' ? (
		appTree
	) : (
		<LaunchDarklyProvider>{appTree}</LaunchDarklyProvider>
	);
}
